export const SENSITIVE_KEYS = [
  "password",
  "newPassword",
  "currentPassword",
  "passwordHash",
  "passwordSalt",
  "token",
  "accessToken",
  "refreshToken",
  "idToken",
  "access_token",
  "refresh_token",
  "secret",
  "clientSecret",
  "client_secret",
  "apiKey",
  "privateKey"
];

export const scrubSensitiveKeys = (input) => {
  if (!input || typeof input !== "object") {
    return input;
  }

  const entries = Object.entries(input).filter(
    ([key]) => !SENSITIVE_KEYS.includes(key)
  );
  return Object.fromEntries(entries);
};
